export default __webpack_public_path__ + "static/media/top.43d80560.png";